import { useMemo } from "react";
import CenterTitle from "../center-title";
import GenericSwiper from "../general-swiper";
import Box from "@mui/material/Box";
import CustomText from "../text";
import { colors } from "@/utils/const";
import { useI18n } from "@/i18n/I18nProvider";

export const ProductsPlans = ({
  sectionTitle,
  titleVariant,
  color = false,
  items = [],
  cardBgColor,
  cardColor,
}) => {
  const { locale } = useI18n();
  const isAR = locale === "ar";
  const mappedItems = useMemo(() => {
    if (!items?.length) return [];

    return items?.map((plan) => ({
      name: plan.title?.text?.[locale],
      description: plan.description?.text?.[locale],
      titleType: plan.title?.type,
      descriptionType: plan.description?.type,
    }));
  }, [items, locale]);

  return (
    <>
      <CenterTitle
        title={sectionTitle}
        title_variant={titleVariant}
        color={color}
      />

      <Box sx={{ mt: 6 }}>
        <GenericSwiper
          showNavigation={false}
          spaceBetween={20}
          autoplayDelay={4000}
          items={mappedItems}
          hasArrows={true}
          arrowColor={colors.navy}
          sx={{
            "& .swiper": { width: "100%" },
            "& .swiper-button-prev, & .swiper-button-next": {
              display: "none !important",
            },
            padding: 0,
          }}
          CardComponent={({
            name,
            description,
            titleType,
            descriptionType,
          }) => (
            <Box
              dir={isAR ? "rtl" : "ltr"}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: 2,
                padding: "20px",
                borderRadius: "20px",
                background: cardBgColor,
                color: cardColor,
                width: { xs: 310, md: 390 },
                height: { xs: 220 },
              }}
            >
              <CustomText
                text={name}
                type="md"
                variant={titleType || "h3"}
                customStyle={{ fontWeight: "700" }}
                enableHtml={true}
              />

              <CustomText
                text={description}
                variant={descriptionType}
                type="xs"
                enableHtml={true}
              />
            </Box>
          )}
          shrink
          type="details"
        />
      </Box>
    </>
  );
};
